// engine
import { ExtendedContainer, Layout } from "@aceroll/core";

// game objects
import { Background, BigWinPopup, FeaturePopup, MultiplierPanel, Ra, TotalWinPopup } from '../gameObjects';
import { SlotMachine } from '../gameObjects/slot/slot-machine';

// constants
import { ORIENTATIONS } from '../constants';

export default class Game extends Layout {
    background = null;
    multiplierPanel = null;
    slotMachine = null;
    character = null;

    featurePopup = null;
    totalWinPopup = null;
    bigWinPopup = null;

    init() {
        super.init();

        this.background = new Background();
        this.multiplierPanel = new MultiplierPanel('spine-multiplier_panel');
        this.slotMachine = new SlotMachine();
        this.character = new Ra();

        // Add the overlay after everything else is initialized
        this.featurePopup = new FeaturePopup();
        this.totalWinPopup = new TotalWinPopup();
        this.bigWinPopup = new BigWinPopup();

        this.background.zIndex = 1;
        this.multiplierPanel.zIndex = 3;
        this.character.zIndex = 4;
        this.slotMachine.zIndex = 5;

        this.featurePopup.zIndex = 8;
        this.totalWinPopup.zIndex = 9;
        this.bigWinPopup.zIndex = 10;

        this.bgContainer = new ExtendedContainer('bgContainer');
        this.bgContainer.scaleMode = 'max';
        this.gameContainer = new ExtendedContainer('gameContainer');

        this.bonusIntroContainer = new ExtendedContainer('bonusIntroContainer');
        this.bonusIntroContainer.scaleMode = 'max';
        this.bonusIntroContainer.addChild(this.featurePopup.spine);
        this.bonusIntroContentContainer = new ExtendedContainer('bonusIntroContentContainer');
        this.bonusIntroContentContainer.addChild(this.featurePopup);

        this.bonusSummaryContainer = new ExtendedContainer('bonusSummaryContainer');
        this.bonusSummaryContainer.scaleMode = 'max';
        this.bonusSummaryContainer.addChild(this.totalWinPopup._spine);
        this.bonusSummaryContentContainer = new ExtendedContainer('bonusSummaryContentContainer');
        this.bonusSummaryContentContainer.addChild(this.totalWinPopup);

        this.root.addChild(
            this.bgContainer,
            this.gameContainer,
            this.bigWinPopup,
            this.bonusIntroContainer,
            this.bonusIntroContentContainer,
            this.bonusSummaryContainer,
            this.bonusSummaryContentContainer
        );
        this.bgContainer.addChild(
            this.background,
        );
        this.gameContainer.addChild(
            this.multiplierPanel,
            this.slotMachine,
            this.character
        );

        this.character.playInitialIdle();
    }

    setMainGameLayout() {
        this.background.setMainGameView();
        this.slotMachine.exitBonus();
        this.character.state = 'main';
    }

    setBonusGameLayout() {
        this.background.setBonusGameView();
        this.slotMachine.onBonus();
        this.character.state = 'bonus';
    }

    onLandscape() {
        this.background.updateOrientation(ORIENTATIONS.LANDSCAPE);
        this.background.position.set(960, 540);

        this.multiplierPanel.position.set(1108, 102);
        this.multiplierPanel.scale.set(0.75);

        this.character.orientation = 'landscape';
        this.character.position.set(240, 590);
        this.character.zIndex = 4;

        this.slotMachine.onOrientationChange('landscape');
        this.slotMachine.position.set(0, -420);

        this.featurePopup.position.set(960, 540);
        this.featurePopup.spine.position.set(960, 540);
        this.totalWinPopup.position.set(960, 540);
        this.totalWinPopup._spine.position.set(960, 540);
        // this.bigWinPopup.position.set(960, 540);
        this.bigWinPopup.onLandscape();

        this.gameContainer.sortChildren();
    }

    onPortrait() {
        this.background.position.set(540, 960);
        this.background.updateOrientation(ORIENTATIONS.PORTRAIT);

        this.multiplierPanel.position.set(528, 572);
        this.multiplierPanel.scale.set(1);

        this.character.orientation = 'portrait';
        this.character.position.set(414, 790);
        this.character.zIndex = 2;

        this.slotMachine.onOrientationChange('portrait');
        this.slotMachine.position.set(-420, 49);

        this.featurePopup.position.set(540, 960);
        this.featurePopup.spine.position.set(540, 960);
        this.totalWinPopup.position.set(540, 1000);
        this.totalWinPopup._spine.position.set(540, 1000);

        // this.bigWinPopup.position.set(540, 960);
        this.bigWinPopup.onPortrait();


        this.gameContainer.sortChildren();
    }
}
